/**
 * NaamDarbar — Theme Toggle Component
 *
 * An animated toggle switch between:
 *   ☀️ Prakash (Saffron/Light)   ↔   🌙 Sukhasan (Deep Blue/Dark)
 *
 * Features a glowing pill toggle with celestial transition effects.
 */

import { useTheme } from '../../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isSukhasan = theme === 'sukhasan';

  return (
    <button
      onClick={toggleTheme}
      aria-label={`Switch to ${isSukhasan ? 'Prakash (Light)' : 'Sukhasan (Dark)'} theme`}
      className="theme-toggle-btn group relative"
      title={isSukhasan ? 'Switch to Prakash (Light)' : 'Switch to Sukhasan (Dark)'}
    >
      {/* Track */}
      <div className="theme-toggle-track">
        {/* Glow effect */}
        <div className="theme-toggle-glow" />

        {/* Sun icon (left side) */}
        <div className={`theme-toggle-icon-left ${isSukhasan ? 'opacity-40' : 'opacity-100'}`}>
          <Sun size={12} strokeWidth={2.5} />
        </div>

        {/* Moon icon (right side) */}
        <div className={`theme-toggle-icon-right ${isSukhasan ? 'opacity-100' : 'opacity-40'}`}>
          <Moon size={12} strokeWidth={2.5} />
        </div>

        {/* Sliding thumb */}
        <div className={`theme-toggle-thumb ${isSukhasan ? 'translate-x-[22px]' : 'translate-x-0'}`}>
          <div className="theme-toggle-thumb-inner">
            {isSukhasan ? (
              <Moon size={10} className="text-blue-200" strokeWidth={2.5} />
            ) : (
              <Sun size={10} className="text-kesri-500" strokeWidth={2.5} />
            )}
          </div>
        </div>
      </div>

      {/* Label */}
      <span className="theme-toggle-label">
        {isSukhasan ? 'Sukhasan' : 'Prakash'}
      </span>
    </button>
  );
}
